import React from "react";
import Foot from "./Foot";
import MovieCard from "./MovieCard";
import Navigation from "./Navigation";
import Submenu from "./Submenu";
import Pagination from "./Pagination";

class Favorites extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            combinedList: [],
            currentPage: 1,
            watchedVisible: false
        };
    }

    componentDidMount() {
        const { favorites, watched, titleChange } = this.props;
        this.setState(state => ({
            ...state,
            ...{
                combinedList: [...favorites, ...watched]
            }
        }));

        titleChange(`Dashboard`);
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.favorites !== prevProps.favorites ||
            this.props.watched !== prevProps.watched
        ) {
            this.setState(state => ({
                ...state,
                ...{
                    combinedList: [
                        ...this.props.favorites,
                        ...this.props.watched
                    ]
                }
            }));
        }
    }

    alphabeticalSort = evt => {
        const sortType = evt.target.value;
        const combinedList = this.state.combinedList;
        if (sortType === "asc") {
            combinedList.sort((a, b) => {
                return a.title < b.title ? -1 : 1;
            });
        } else if (sortType === "desc") {
            combinedList.sort((a, b) => {
                return a.title > b.title ? -1 : 1;
            });
        }
        this.setState(state => ({
            ...state,
            ...{ combinedList: combinedList }
        }));
    };

    timestampSort = evt => {
        const sortType = evt.target.value;
        const timecombinedList = this.state.combinedList;

        if (sortType === "asc") {
            timecombinedList.sort((a, b) => {
                var dateA = new Date(a.release_date),
                    dateB = new Date(b.release_date);
                return dateA - dateB;
            });
        } else {
            timecombinedList.sort((a, b) => {
                var dateA = new Date(a.release_date),
                    dateB = new Date(b.release_date);
                return dateB - dateA;
            });
        }

        this.setState(state => ({
            ...state,
            ...{ combinedList: timecombinedList }
        }));
    };

    popularitySort = evt => {
        const sortType = evt.target.value;
        const popularitycombinedList = this.state.combinedList;

        if (sortType === "asc") {
            popularitycombinedList.sort((a, b) => {
                return a.popularity - b.popularity;
            });
        } else {
            popularitycombinedList.sort((a, b) => {
                return b.popularity - a.popularity;
            });
        }

        this.setState(state => ({
            ...state,
            ...{ combinedList: popularitycombinedList }
        }));
    };

    onFavoritesSearch = movieTitle => {
        const existingFavorites = this.state.combinedList.filter(movie =>
            movie.title.toLowerCase().includes(movieTitle.toLowerCase())
        );
        console.log(existingFavorites);
        this.setState(state => ({
            ...state,
            ...{ combinedList: existingFavorites }
        }));
    };

    clearMovies = () => {
        const { clearMyLists } = this.props;
        localStorage.setItem("favorites", "");
        localStorage.setItem("watched", "");
        clearMyLists();
    };
    
    clearFilter = () => {
        this.setState(state => ({
            ...state,
            ...{
                combinedList: [
                    ...this.props.favorites,
                    ...this.props.watched
                ]
            }
        }));
    }

    filterMovies = evt => {
        const filterBy = evt.target.value;

        if (filterBy === "favorites") {
            this.setState(state => ({
                ...state,
                ...{ watchedVisible: false }
            }));
        } else if (filterBy === "watched") {
            this.setState(state => ({
                ...state,
                ...{ watchedVisible: true }
            }));
        }
    };

    paginate = (moviesList, pageContentsSize, totalPageNumsToDisplay) => {
        --totalPageNumsToDisplay;
        return moviesList.slice(
            totalPageNumsToDisplay * pageContentsSize,
            (totalPageNumsToDisplay + 1) * pageContentsSize
        );
    };

    onPaginateChange = page => {
        console.log(page);
        this.setState(state => ({
            ...state,
            ...{ currentPage: page }
        }));
    };

    render() {
        const {
            onSearch,
            favorites,
            favoriteCallback,
            totalFavorites,
            totalWatched,
            searchKeyUpdate,
            watchedToggle,
            watched,
            updateFavorites
        } = this.props;

        return (
            <div>
                <Navigation
                    onSearch={onSearch}
                    totalFavorites={totalFavorites}
                    searchKeyUpdate={searchKeyUpdate}
                    totalWatched={totalWatched}
                />

                <div className="container">
                    <Submenu
                        onFavoritesSearch={this.onFavoritesSearch}
                        sortByTitle={this.alphabeticalSort}
                        sortByDate={this.timestampSort}
                        sortByPopularity={this.popularitySort}
                        clearMovies={this.clearMovies}
                        watched={watched}
                        filterWatched={this.filterWatched}
                        filterFavorites={this.filterFavorites}
                        updateFavorites={updateFavorites}
                        filterMovies={this.filterMovies}
                        clearFilter={this.clearFilter}
                    />
                    {this.state.combinedList &&
                    this.state.combinedList.length < 1 ? (
                        <h1
                            style={{
                                fontSize: "18px",
                                textAlign: "center",
                                margin: "10% 0 10% 0"
                            }}
                        >
                            Your favorites list is currently empty, please mark
                            some of the movies as favorites!
                        </h1>
                    ) : (
                        <ul className="movies">
                            {this.state.combinedList &&
                            !this.state.watchedVisible
                                ? this.paginate(
                                      [...this.state.combinedList].filter(
                                          movie =>
                                              !movie.hasOwnProperty(
                                                  "timestamp"
                                              ) || !movie.timestamp
                                      ),
                                      25,
                                      this.state.currentPage
                                  ).map(movie => (
                                      // Watched.
                                      <MovieCard
                                          movie={movie}
                                          key={movie.id}
                                          toggleFavorite={favoriteCallback}
                                          favorites={favorites}
                                          watchedToggle={watchedToggle}
                                          watched={watched}
                                          isBlurred={false}
                                      />
                                  ))
                                : this.paginate(
                                      [...this.state.combinedList].filter(
                                          movie =>
                                              movie.hasOwnProperty(
                                                  "timestamp"
                                              ) && movie.timestamp
                                      ),
                                      25,
                                      this.state.currentPage
                                  ).map(movie => (
                                      // Watched.
                                      <MovieCard
                                          movie={movie}
                                          key={movie.id}
                                          toggleFavorite={favoriteCallback}
                                          favorites={favorites}
                                          watchedToggle={watchedToggle}
                                          watched={watched}
                                          isBlurred={false}
                                      />
                                  ))}
                        </ul>
                    )}

                    <Pagination
                        totalPages={
                            this.state.watchedVisible
                                ? [...this.state.combinedList].filter(
                                      watched =>
                                          watched.hasOwnProperty("timestamp") ||
                                          watched.timestamp
                                  ).length /
                                      25 +
                                  1
                                : [...this.state.combinedList].filter(
                                      notwatched =>
                                          !notwatched.hasOwnProperty(
                                              "timestamp"
                                          ) || !notwatched.timestamp
                                  ).length /
                                      25 +
                                  1
                        }
                        currentPage={this.state.currentPage}
                        onPageChange={this.onPaginateChange}
                    />

                    <Foot />
                </div>
            </div>
        );
    }
}

export default Favorites;



// WEBPACK FOOTER //
// ./src/components/Dashboard.js